import React from "react";
import clsx from "clsx";
import AddButton from "../../AddButton/AddButton";
import RoomTypePriceBuilderErrors from "../RoomTypePriceBuilderErrors";
import SeasonalPriceBuilder from "../../SeasonalPriceBuilder/SeasonalPriceBuilder";

class RoomTypePriceBuilderSeasonalPricing extends React.Component {
  constructor(props) {
    super(props);

    this.onAddSeasonalPrice = this.onAddSeasonalPrice.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onRemoveSeasonalPrice = this.onRemoveSeasonalPrice.bind(this);
  }

  render() {
    var self = this;

    var tabClasses = clsx({
      active: this.props.active_tab == "seasonal_pricing",
      "tab-pane": true,
    });

    var seasonal_prices = this.props.seasonal_prices.map(function (
      seasonal_price
    ) {
      return (
        <SeasonalPriceBuilder
          room_type_price={{
            start_date: self.props.start_date,
            sunday_amount: self.props.sunday_amount,
            monday_amount: self.props.monday_amount,
            tuesday_amount: self.props.tuesday_amount,
            wednesday_amount: self.props.wednesday_amount,
            thursday_amount: self.props.thursday_amount,
            friday_amount: self.props.friday_amount,
            saturday_amount: self.props.saturday_amount,
          }}
          key={seasonal_price.id}
          {...seasonal_price}
          date_format={self.props.date_format}
          onChange={self.onChange}
          onRemove={self.onRemoveSeasonalPrice}
          onChangeAllDays={
            self.props && self.props.onChangeAllDays
              ? self.props.onChangeAllDays
              : null
          }
          onChangeAllMinimumStays={
            self.props && self.props.onChangeAllMinimumStays
              ? self.props.onChangeAllMinimumStays
              : null
          }
          read_only={self.props.read_only}
        />
      );
    });

    return (
      <div className={tabClasses} id="seasons">
        {this.renderErrors()}

        <div
          className="panel panel-default"
          style={{ marginTop: 5, marginBottom: 0 }}
        >
          <div className="panel-heading">
            <h3 className="panel-title pull-left">
              {I18n.t("seasonal_prices")}
              <span
                className="ss-help help"
                title={I18n.t("room_type_price_seasonal_prices_helper_text")}
              ></span>
            </h3>
            {this.props.read_only ? null : (
              <div className="pull-right">
                <AddButton
                  model="SeasonalPrice"
                  ids={
                    this.props.seasonal_prices
                      ? this.props.seasonal_prices.map((seasonal_price) => {
                          return seasonal_price.season_id;
                        })
                      : null
                  }
                  onAdd={this.onAddSeasonalPrice}
                  new_in_modal={this.props.new_season_path}
                  create_new_text={I18n.t("new_season")}
                />
              </div>
            )}
            <div className="clearfix"></div>
          </div>
          <div className="panel-body">
            {seasonal_prices && seasonal_prices.length > 0 ? (
              seasonal_prices
            ) : (
              <div className="no-records">
                <span className="none">{I18n.t("none")}</span>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  renderErrors() {
    var errors = RoomTypePriceBuilderErrors.seasonal_pricing(this.props.errors);

    if (errors && errors.length) {
      var idx = 0;
      var errors = errors.map((error) => {
        idx = idx + 1;
        return <li key={error + idx}>{error}</li>;
      });

      return (
        <div className="alert alert-danger">
          <ul>{errors}</ul>
        </div>
      );
    }
  }

  /**
   * Change handlers
   */

  onAddSeasonalPrice(season) {
    var seasonal_prices = this.props.seasonal_prices.slice(0);
    var seasonal_price = {
      id: this.generateId(),
      season: season,
      season_id: season ? season.id : "-0",
      room_type_price_id: this.props.id,
    };

    seasonal_prices.unshift(seasonal_price);
    this.props.onChangeSeasonalPrices(seasonal_prices);
  }

  onChange(seasonal_price) {
    var seasonal_prices = this.props.seasonal_prices.slice(0);
    var idx = this.getSeasonalPriceIndexById(seasonal_price.id);
    seasonal_price.room_type_price_id = this.props.id;
    seasonal_prices[idx] = seasonal_price;
    this.props.onChangeSeasonalPrices(seasonal_prices);
  }

  onRemoveSeasonalPrice(seasonal_price_id) {
    var seasonal_prices = this.props.seasonal_prices.slice(0);
    var idx = this.getSeasonalPriceIndexById(seasonal_price_id);

    if (idx >= 0) {
      seasonal_prices.splice(idx, 1);
      this.props.onChangeSeasonalPrices(seasonal_prices);
    }
  }

  /**
   * Helper functions
   */

  getSeasonalPriceIndexById(id) {
    for (var i = 0, ilen = this.props.seasonal_prices.length; i < ilen; i++) {
      if (this.props.seasonal_prices[i].id == id) {
        return i;
      }
    }
  }

  generateId() {
    var text = "";
    var possible = "0123456789";

    for (var i = 0; i < 9; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }

    return "-" + text;
  }
}

export default RoomTypePriceBuilderSeasonalPricing;
